import React from "react";

export default function ImplementationBiosensor(props) {
    return (
        <div>
            <div
                style={{
                    background: "rgb(175,234,255) linear-gradient(180deg, rgba(175,234,255,1) 0%, rgba(87,174,255,1) 47%, rgba(40,57,255,1) 100%)",
                    minHeight: "100vh",
                }}>
                <div
                    className="fixed bottom-0 w-full py-8 px-4 flex justify-around text-2xl text-white cano"
                    style={{backgroundColor: "rgba(87,174,255,.7)"}}>
                    <a href="#detection_and_quantification">Overview</a>
                    <a href="#biological_receptor">Biologicar Receptor hERa</a>
                    <a href="#immobilization_title">Immobilization</a>
                    <a href="#software_title">Software</a>
                    <a href="#3d_printed_title">3D Printed Case</a>
                </div>
                <div className="hero">
                    <img
                        src="https://static.igem.wiki/teams/4260/wiki/engineering/moneda-biosensor.png"
                        alt="Biosensor coin"
                        className="w-full"
                    />
                    <div className="w-full flex justify-around items-center">
                        <div onClick={props.switchPage} className="p-8 clickable">
                            <svg
                                width="76.7"
                                height="135.2"
                                viewBox="0 0 59 104"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path d="M55 4L7 52L55 100" stroke="#233876" stroke-width="9"/>
                            </svg>
                        </div>
                        <div className="flex flex-col items-center">
                            <h2 className="text-3xl cano text-blue-900"> IMPLEMENTATION </h2>
                            <h1 className="text-8xl cano text-blue-900"> BIOSENSOR</h1>
                        </div>
                        <div onClick={props.switchPage} className="p-8 clickable">
                            <svg
                                width="76.7"
                                height="135.2"
                                viewBox="0 0 59 104"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path d="M4 100L52 52L4 4" stroke="#233876" stroke-width="9"/>
                            </svg>
                        </div>
                    </div>
                </div>
                <div className="h-full w-full">
                    <div className="p-10 max-w-5xl m-auto pt-20 text-white">
                        <h1 className="text-6xl text-center text-white font-bold">Biosensor</h1>
                        <p className="p">
                            <br/>
                            Our biosensor is a partial follow-up of our past year-team’s project,
                            in relation to identifying EDCs. As an improvement we wanted to detail
                            even deeper and more specifically the fields of implementation of the
                            biosensor. Our final work is planned to be applied into two main
                            fields: Study and Environmental Assessment. Within these, we are
                            making our biosensor versatile to serve as a measurement tool in
                            laboratories for the wide variety of existing EDCs and different
                            samples.
                            <br/>
                            <br/>
                            We aim that our biosensor helps the creation and development of other
                            similar measuring instruments from our starting prototype. <br/>
                            <img
                                src="https://static.igem.wiki/teams/4260/wiki/biosensor-model-assambled.jpg"
                                alt="biosensor-model-assambled"
                                className="figure"
                            />
                            <p className="figure_desc">
                                <strong>Fig. 1 </strong>Model of Biosensor by TecCEM
                            </p>
                            <p className="p"></p>
                            <br/>
                            <h3 className="h3">Proposed end users and usage</h3>
                            <br/>
                            <br/>
                            Our proposed users are mainly, but not exclusively, water quality
                            companies, regulatory agencies, and research institutions. <br/>
                            We highly expect the biosensor to be implemented in the{" "}
                            <strong>environmental quality regulation field</strong>, in which it
                            is necessary to know and analyze the conditions and properties of the
                            water that is used in irrigation samples. In this field, our proposed
                            users are water quality companies, regulatory agencies and
                            water-related industries, as well as companies that generate plastics.
                            <br/>
                            <em>
                                → For these users the keywords are: economic, durable and
                                environmentally safe.
                            </em>
                            <br/>
                            <br/>
                            <br/>
                            On the other hand, our proposed users in the{" "}
                            <strong>research field</strong> involve{" "}
                            <strong>institutes and laboratories.</strong> From our experts'
                            interviews a variety of professionals suggested a tool as our
                            biosensor would facilitate the development of their investigations.
                            For example:
                            <br/>
                            <br/>
                            ● PhD. Edson Estrada; in the proof of concept of his degradation
                            bioreactor.
                            <br/>
                            ● PhD. Mauricio Rodríguez and PhD student Sergio Alberto in their
                            prostate cancer associated with EDCs research.
                            <br/>
                            <br/>
                            <em>
                                → For these users the keywords are: economic, easy to use, durable
                                and effective.
                            </em>
                            <br/>
                            <br/>
                            Although these two proposed end users could be far apart from each
                            other, we envision them using our biosensor as a crucial tool to
                            continue their studies on EDCs-water analysis related projects. <br/>
                            <img
                                src="https://static.igem.wiki/teams/4260/wiki/implementation-biosensor.png"
                                alt="implementation biosensor"
                                className="figure"
                            />
                            <h3 className="h3">Vision</h3>
                            We believe that our biosensor is able to help solve relevant and
                            global issues related to water quality-analysis. We consider that the
                            quantification of EDCs is important because they act not only as
                            contaminants for the marine environment and wildlife but also as
                            nocive substances for the human genetic, metabolic and neurological
                            health. According to one of our stakeholders, our bionsensor acts as a
                            viable solution in water quality-testing companies as both an analysis
                            tool and a correct check up and calibration of their machinery too.
                            Nevertheless, awareness is needed, the government and our community
                            have to be well informed about the problematic we are currently living
                            in, a chore we decided to encompass, please see more at Human
                            Practices. This with the objective of reaching regulatory agencies or
                            an integration into the compulsory standard framework in our country:
                            whether in the form of a NOM or NMX. With our biosensor we also hope
                            to aid in the development of our national legislative framework for
                            the regulation of emissions of EDCs.
                            <h3 className="h3">Ease of use</h3>
                            Our focus is on the development of hardware and software, with the aim
                            of creating a more simple use in both the design and the user
                            interface. Obtaining simplified and reliable data would ease the
                            experience for the users while manipulating the biosensor with details
                            such as bluetooth connection would reduce space and external
                            specifications.
                            <br/>
                            <br/>
                            The design was worked around to be attractive, friendly and of suitable
                            dimensions to accommodate the environment of our end users. As for the
                            operation with the samples, initially, for the balance to measure the
                            samples it was through the use of a chip focused on the creation of
                            microfluidic "droplets". But the desired outcome was not met as well,
                            it was a complicated operation for the user with this method. To meet
                            the requirements, the design was changed to a rectangular amber glass
                            chamber, due to the need for an airtight space for the sample, without
                            sacrificing the practicality of the biosensor.
                            <br/>
                            <br/>
                            <h3 className="h3">Challenges, development and technology</h3>
                            <br/>
                            Nowadays there is a lack of awareness on the presence of EDCs in
                            everyday products and their effects on human health and on the
                            environment. There are also not enough efficient detection systems,
                            even though there are methods of sensing these chemicals such as
                            High-Performance Liquid Chromatography (HPLC) and other
                            electrochemical methods, they require specialized personnel.
                            Considering that they are high cost solutions and they are mainly
                            meant for qualitative analysis, not quantitative. <br/>
                            <br/>
                            The assembly of our biosensor may prove to be a complex task,
                            requiring taking into account several environmental factors that
                            affect the composition of the sample; though being a challenge, it
                            allows for the synergy with other technologies in order to make up for
                            the variability of the environmental factors, and the versatility of
                            the biosensor. Through this the EDC sensing methods can be more
                            efficient, less costly, quantifiable and more versatile.
                            <br/>
                            <br/>
                            There are new fast development methods for particle detection, with
                            more sensitive and specific capture methods. Important factors for us
                            that help to make the technology more feasible for everyone as well
                            for the development of more precise parts for the individual elements
                            of our hardware.
                            <br/>
                            <br/>
                            <h3 className="h3">Limitations</h3>
                            <br/>
                            A main limitation is around its end objective, because to arrive at
                            its main goal to work around legislative frameworks it is precisely
                            necessary to collaborate with local governments. To learn more about
                            how we are working to solve this issue visit our Human Practices tab.
                            Though there are several bottlenecks around this problem, there are
                            also workarounds: the mass production of the biosensor, though
                            challenging and complex, it is not necessary if it is working around
                            the right environment and the right usage, since it works with
                            relative small samples for detection of EDCs.
                            <br/>
                            <br/>
                            <h3 className="h3">Dual Use</h3>
                            <br/>
                            One of our greatest concerns within our project is tackling issues
                            surrounding our technology through biosafety and biosecurity. Dual-use
                            consists of carrying out a biological research aiming for some
                            specific scientific purpose, but taking into account that the results
                            could also be encompassed with misused practices and activities to
                            pose a biological threat to the world population.
                            <br/>
                            <br/>
                            <strong>1) Biosafety</strong>
                            <br/>
                            In terms of biosafety, the immobilization of our biosensor avoids the
                            interaction with the environment, and prevents it from going into the
                            samples run through the biosensor. Our recombinant protein would be
                            inside a chamber, avoiding its release. In the case of accidental
                            interaction with the environment through misuse or other means, our
                            biosensor, being eco-friendly, does not harm or affect the environment
                            nor living organisms. <br/>
                            <br/>
                            <br/>
                            <strong>2) Biosecurity</strong>
                            <br/>
                            The right usage of any biological and chemical materials is critical
                            to ensure the biosecurity, thus, through the development of our
                            biosensor, the team made use of good practices to avoid accidental
                            exposure to any harmful agents, such as proper sterilization
                            techniques, chemical inactivation of biological materials and the
                            usage and sterilization of gloves. <br/>
                            <br/>
                            <br/>
                            <h3 className="h3">
                                What are the safety aspects you would need to consider?
                            </h3>
                            <br/>
                            The usage of an immobilized receptor protein ensures that it will not
                            get transferred into the sample run, avoiding its release to the
                            environment. Therefore it can be said that our protein shows safety
                            aspects needed to be considered.
                            <br/>
                            <br/>
                            <br/>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
}